export default "__VITE_ASSET__b68a7741__"